module.exports = __webpack_public_path__ + "img/1440.ddfa9284.svg";